import { WorkLog } from "@wingspanhq/wingspan-api-sdk";

/**
 * How a work log is identified in lists: its human-facing `externalId` (the
 * work log number, e.g. "WL-01"), falling back to the id when a log has none.
 */
export const selectorWorkLogLabel = (workLog: WorkLog): string =>
  workLog.externalId ?? workLog.id ?? "";
